var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransportePatineteRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "4mev1tsieb",
    d: "M0 0L6.016 0 6.016 5.919 0 5.919z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#575756",
    d: "M4.086 15.08c-1.659 0-3.008 1.329-3.008 2.96 0 1.632 1.35 2.96 3.008 2.96s3.008-1.328 3.008-2.96c0-1.631-1.35-2.96-3.008-2.96",
    transform: "translate(2.000000, 4.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.000000, 4.000000) translate(17.984085, 15.080852)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#575756",
    d: "M3.008 0C1.35 0 0 1.328 0 2.96s1.35 2.96 3.008 2.96c1.659 0 3.008-1.328 3.008-2.96S4.666 0 3.008 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#575756",
    d: "M20.894 12.013c.007-.007.01-.016.016-.024.015-.02.028-.04.04-.061.012-.02.023-.038.033-.058.01-.02.017-.042.025-.063.008-.022.015-.043.02-.065.006-.022.01-.044.013-.066.003-.023.006-.046.007-.069v-.064c-.002-.025-.004-.05-.008-.075-.001-.01 0-.018-.002-.028L18.758 0h-4.495c-.393 0-.712.314-.712.7 0 .387.32.7.712.7h3.324l1.99 9.99-4.852 5.95H9.069c-.347-2.4-2.449-4.253-4.983-4.253-1.535 0-2.968.677-3.93 1.857-.245.302-.196.742.11.984.307.242.755.194 1.001-.108.69-.847 1.718-1.332 2.82-1.332 1.99 0 3.61 1.594 3.61 3.553 0 .387.318.7.711.7H15.066c.045 0 .09-.005.133-.013l.015-.003c.04-.008.079-.02.117-.035l.02-.008c.037-.016.072-.035.105-.057l.017-.01c.033-.024.065-.049.095-.078l.005-.005c.016-.017.033-.034.048-.053l5.273-6.466z",
    transform: "translate(2.000000, 4.000000)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportePatineteRed);
export default __webpack_public_path__ + "static/media/transportePatineteRed.60b7d8cf.svg";
export { ForwardRef as ReactComponent };